<div class="container-building" data-selenium="certificates-container">

  <div class="container">
    @if (tableData.length > 0) {
    <div class="table-alignment" data-selenium="certificates-table-section">
      <ia-table data-selenium="certificates-table" [theme]="'neutral'" [configuration]="tableWithThreeDotMenuConfiguration" [data]="tableData"
        [pagination]="false" [step]="10" [totalRecords]="totalCertificates" (pageNavigation)="pageNavigation($event)"
        [localData]="false" [localSort]="true" [columns]="tableColumns"
        #certificateTable>
      </ia-table>
       <div class="create-button-container" data-selenium="create-certificate-container" *ngIf="this.totalCertificates">
        <ia-button data-selenium="create-certificate-btn" class="right-align" (click)="openCreateCerDialog()">{{
          "building_integrations.CREATE_CERTIFICATE" | translate
          }}</ia-button>
      </div>
    </div>
    }

    <div *ngIf="!this.totalCertificates" class="no-certificates" data-selenium="no-certificates-section">
      <h4 data-selenium="no-certificates-title">{{ "building_integrations.NO_CERTIFICATES" | translate }}</h4>

      @if (!isShowInstruction) {
      <p #insPara data-selenium="show-instructions-link" (click)="isShowInstruction = !isShowInstruction" (keydown)="onInstructionKey($event)"
        [innerHTML]="'building_integrations.CERTIFICATE_INS_1' | translate" class="instruction"></p>
      } @else {
      <div data-selenium="certificate-instructions">
        <p data-selenium="instruction-step-2" [innerHTML]="'building_integrations.CERTIFICATE_INS_2' | translate"></p>
        <p class="code" data-selenium="instruction-code" [innerHTML]="'building_integrations.CERTIFICATE_INS_CODE' | translate"></p>
        <p data-selenium="instruction-step-3">{{ "building_integrations.CERTIFICATE_INS_3" | translate }}</p>
      </div>
      }
      <ia-button data-selenium="create-certificate-btn-empty" (click)="openCreateCerDialog()">{{
        "building_integrations.CREATE_CERTIFICATE" | translate
        }}</ia-button>
    </div>
  </div>
</div>


<!-- Create certificate dialog -->
<div class="dialog" data-selenium="create-certificate-dialog" *iaDialog="certificateCreatorDialog">
  <div class="dialog-header">
    <h1 class="dialog-title" data-selenium="create-certificate-dialog-title">
      {{ "building_integrations.CREATE_CERTIFICATE" | translate }}
    </h1>
  </div>
  <div class="dialog-content" data-selenium="create-certificate-dialog-content">
    @if ( isCreating ) {
    <ng-container *ngTemplateOutlet="certificateCreatingTpl"></ng-container>
    } @else {
    <ng-container *ngTemplateOutlet="certificateCreatorTpl"></ng-container>
    }
  </div>
  <div class="dialog-footer" data-selenium="create-certificate-dialog-footer">
    <button class="quiet" data-selenium="cancel-create-certificate" translate="common.CANCEL"
      (click)="certificateCreatorDialog.cancel(); logClickOnCancelEventInCreateCertificate()"></button>
    <button class="primary" data-selenium="create-certificate-submit" translate="common.CREATE" (click)="createCertificate()"
      [disabled]="!cerFileName || fileInvalidError"></button>
  </div>

  <ng-template #certificateCreatorTpl>
    <p class="ins-text" data-selenium="certificate-creation-tip">{{ "building_integrations.CREATE_CERTIFICATE_TIP" | translate }}</p>

    <ia-form-field data-selenium="csr-file-form-field" [required]="true" [showError]="!!fileInvalidError" [errorMessage]="fileInvalidError">
      <ia-label for="fileInput">{{ 'building_integrations.CERTIFICATE_SIGNING_REQUEST_FILE' | translate }}</ia-label>
      <div class="file-box">
        <button class="neutral browse" data-selenium="browse-file-btn">
          {{ "common.BROWSE" | translate }}
        </button>
        <input #fileInput data-selenium="file-input" type="file" hidden required accept=".csr" (change)="onChangeFile()" name="cerFile" />
      </div>
      <div *ngIf="cerFileName" class="file-content" data-selenium="selected-file-info">
        <span data-selenium="selected-filename">{{ cerFileName }}</span>
        <a data-selenium="remove-file-btn" (click)="removeCerFile()">{{ "common.REMOVE" | translate }}</a>
      </div>
    </ia-form-field>
    <em class="error" data-selenium="file-error-message" [hidden]="!fileInvalidError">
      {{ fileInvalidError }}
    </em>
  </ng-template>

  <ng-template #certificateCreatingTpl>
    <div class="creating-content" data-selenium="certificate-creating-loader">
      <ia-loader></ia-loader>
      <ia-spinner size="large"></ia-spinner>
      <p data-selenium="uploading-csr-text">{{ "building_integrations.UPLOADING_CSR" | translate }}</p>
    </div>
  </ng-template>
</div>

<!-- Action menu for download and delete -->
<ng-template #contextMenuTemplate let-row let-rowIndex="rowIndex">
  <div class="menu-container" data-selenium="certificate-actions-menu">
    <ia-button theme="quiet" data-selenium="certificate-menu-trigger" [iaTriggerMenu]="defaultMenu" class="menu-button">
      <!-- <img
        src="/assets/images/icons/ellipsis.svg"
        alt="Check Icon"
        width="20"
        height="20"
        class="icon"
      /> -->
    </ia-button>
    <ia-menu #defaultMenu class="menu-dialog" data-selenium="certificate-actions-dropdown">
      <button class="download-button" data-selenium="download-certificate-action" (click)="downloadCer(row)">
        {{ "building_integrations.DOWNLOAD" | translate }}
        <span class="download-icon"></span>
      </button>
      <button class="delete-button" data-selenium="delete-certificate-action"
        (click)="certificateDeleteDialog.open();assignCertificateToDelete(row)">
        {{ "common.DELETE" | translate }}
        <span class="delete-icon"></span>
      </button>
    </ia-menu>
  </div>
</ng-template>

<!-- Delete certificate confirm dialog -->
<div class="dialog" data-selenium="delete-certificate-dialog" *iaDialog="certificateDeleteDialog">
  <div class="dialog-header">
    <h1 class="dialog-title" data-selenium="delete-certificate-dialog-title">
      {{ "common.CONFIRM_DELETE" | translate }}
    </h1>
  </div>
  <div>
    <p class="dialog-content" data-selenium="delete-certificate-confirmation-text" [innerHTML]="deleteCertConfirmText">
    </p>
    <div class="dialog-footer" data-selenium="delete-certificate-dialog-footer">
      <button class="quiet" data-selenium="cancel-delete-certificate" translate="common.CANCEL"
        (click)="certificateDeleteDialog.cancel(); logClickOnCancelEvent()"></button>
      <button class="primary" data-selenium="confirm-delete-certificate" translate="common.DELETE"
        (click)="deleteCertificate(certificateToDelete)"></button>
    </div>
  </div>
</div>